import React from 'react';
import {useNavigate, useParams} from 'react-router-dom';
import Table from 'shared/migration-components/table';
import {AccessControlProps} from 'modules/access-controls/types';
import useCompanyAccessControls from 'modules/companies/hooks/use-company-access-controls';
import QueryDeleteButton from 'shared/migration-components/query-delete-button';
import companiesKeys from 'modules/companies/util/companies-keys';

const AccessControls: React.FC = () => {
  const {id} = useParams();
  const {data, isLoading} = useCompanyAccessControls(id!);
  const navigate = useNavigate();

  return (
    <Table<AccessControlProps>
      loading={isLoading}
      data={data ?? []}
      options={[
        'user.name',
        'permissionGroup.name',
        {
          value: 'id',
          label: 'Ações',
          column: (row) => (
            <QueryDeleteButton
              url={`/access-controls/${row.id}`}
              queryKey={companiesKeys.accessControls(id!)}
              type="update"
            />
          ),
        },
      ]}
      translatedPropsKey="AccessControlProps"
      onRowClick={() => null}
    />
  );
};

export default AccessControls;
